var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveJob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82051 5.53846C4.11246 5.53846 3.53846 6.11246 3.53846 6.82051V17.0769C3.53846 17.785 4.11246 18.359 4.82051 18.359H19.1795C19.8875 18.359 20.4615 17.785 20.4615 17.0769V8.8718C20.4615 8.16374 19.8875 7.58974 19.1795 7.58974H13.0256C12.8216 7.58974 12.626 7.5087 12.4817 7.36444L10.6557 5.53846H4.82051ZM2 6.82051C2 5.26279 3.26279 4 4.82051 4H10.9744C11.1784 4 11.374 4.08104 11.5183 4.2253L13.3443 6.05128H19.1795C20.7372 6.05128 22 7.31407 22 8.8718V17.0769C22 18.6347 20.7372 19.8974 19.1795 19.8974H4.82051C3.26279 19.8974 2 18.6347 2 17.0769V6.82051Z",
    fill: "#70758F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.04999H13V7.54999H3V6.04999Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveJob);
export default __webpack_public_path__ + "static/media/archive-job.89522304c1f438185611745fef765296.svg";
export { ForwardRef as ReactComponent };